/**
 * corsiSicurezza.js — catalogo dei corsi e-learning venduti da MB Consulting,
 * soggetto attuatore in convenzione con O.P.N. Italia Lavoro.
 *
 * Catalogo importato il 18/09/2026, da verificare con la piattaforma attuale.
 * `ore` e `titoloAttestato` sono i dati ufficiali della piattaforma.
 * `prezzo` è in euro, IVA compresa (regime forfettario: operazione senza IVA).
 * null = prezzo da definire, la pagina non mostra
 * il corso finché il prezzo è null.
 *
 * NOTA: i riferimenti normativi vanno confermati con l'ente prima di pubblicare.
 */

import { programmi } from './programmiCorsi';

export const categorie = [
  { id: 'lavoratori',   nome: 'Lavoratori',              descrizione: 'Formazione obbligatoria per tutti i dipendenti' },
  { id: 'datore',       nome: 'Datore di lavoro',        descrizione: 'Obblighi formativi di chi guida l’azienda' },
  { id: 'dirigenti',    nome: 'Dirigenti',               descrizione: 'Chi attua le direttive del datore di lavoro' },
  { id: 'rspp',         nome: 'RSPP e ASPP',             descrizione: 'Servizio di prevenzione e protezione' },
  { id: 'rls',          nome: 'RLS',                     descrizione: 'Rappresentante dei lavoratori per la sicurezza' },
  { id: 'cantieri',     nome: 'Cantieri',                descrizione: 'Coordinatori e moduli aggiuntivi per il settore edile' },
  { id: 'formatori',    nome: 'Formatori',               descrizione: 'Qualificazione del formatore in materia di sicurezza' },
  { id: 'haccp',        nome: 'HACCP e alimentaristi',   descrizione: 'Igiene degli alimenti per chi lavora nel settore alimentare' },
];

export const corsi = [
  // ---------------------------------------------------------------- LAVORATORI
  {
    id: 'formazione-generale-lavoratori-4h',
    categoria: 'lavoratori',
    titolo: 'Formazione generale dei lavoratori',
    titoloAttestato: 'CORSO DI FORMAZIONE GENERALE PER I LAVORATORI - 4 ORE',
    ore: 4,
    aggiornamento: false,
    destinatari: 'Tutti i lavoratori dipendenti, qualunque sia il settore',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: '001',
    idEnte: 41,
    immagine: '/img/corsi/formazione-generale-lavoratori-4h.webp',
    prezzo: 35,
  },
  {
    id: 'formazione-generale-lavoratori-4h-eng',
    categoria: 'lavoratori',
    titolo: 'Formazione generale dei lavoratori — in inglese',
    titoloAttestato: 'CORSO DI FORMAZIONE GENERALE PER I LAVORATORI - 4 ORE (ENG)',
    ore: 4,
    aggiornamento: false,
    destinatari: 'Lavoratori di lingua inglese',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: 'corade_120',
    idEnte: 87,
    immagine: '/img/corsi/formazione-generale-lavoratori-4h-eng.webp',
    prezzo: 40,
  },
  {
    id: 'formazione-specifica-rischio-basso-4h',
    // il titolo parte molto in alto: ancorando in alto non gli si mangia il margine
    categoria: 'lavoratori',
    titolo: 'Formazione specifica — rischio basso',
    titoloAttestato: 'CORSO DI FORMAZIONE SPECIFICA DEI LAVORATORI PER I SETTORI DELLA CLASSE DI RISCHIO BASSO - 4 ORE',
    ore: 4,
    aggiornamento: false,
    destinatari: 'Lavoratori di uffici, commercio, servizi e altri settori a rischio basso',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: 'forcih_462',
    idEnte: 42,
    immagine: '/img/corsi/formazione-specifica-rischio-basso-4h.webp',
    prezzo: 39,
  },
  {
    id: 'formazione-specifica-rischio-basso-turismo-4h',
    categoria: 'lavoratori',
    titolo: 'Formazione specifica — rischio basso: turismo e ristorazione',
    titoloAttestato: 'CORSO DI FORMAZIONE SPECIFICA PER LAVORATORI RISCHIO BASSO (SETTORE ALLOGGIO, TURISMO E RISTORAZIONE)',
    ore: 4,
    aggiornamento: false,
    destinatari: 'Lavoratori di alberghi, strutture ricettive, bar e ristoranti a rischio basso',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: 'opn-373',
    programmaDa: 'formazione-specifica-rischio-basso-4h',
    immagine: '/img/corsi/formazione-specifica-rischio-basso-turismo-4h.webp',
    prezzo: 50,
  },
  {
    id: 'formazione-specifica-rischio-basso-uffici-4h',
    categoria: 'lavoratori',
    titolo: 'Formazione specifica — rischio basso: uffici e servizi',
    titoloAttestato: 'CORSO DI FORMAZIONE SPECIFICA PER LAVORATORI RISCHIO BASSO (SETTORE ATTIVITA\' DI UFFICIO, AMMINISTRATIVE E DI SERVIZI DI SUPPORTO ALLE IMPRESE)',
    ore: 4,
    aggiornamento: false,
    destinatari: 'Impiegati di uffici, attività amministrative e servizi di supporto alle imprese',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: 'opn-377',
    programmaDa: 'formazione-specifica-rischio-basso-4h',
    immagine: '/img/corsi/formazione-specifica-rischio-basso-uffici-4h.webp',
    prezzo: 50,
  },
  {
    id: 'formazione-specifica-rischio-basso-4h-eng',
    categoria: 'lavoratori',
    titolo: 'Formazione specifica — rischio basso — in inglese',
    titoloAttestato: 'SPECIFIC SAFETY TRAINING COURSE FOR WORKERS (LOW-RISK SECTOR)',
    ore: 4,
    aggiornamento: false,
    destinatari: 'Lavoratori di lingua inglese di settori a rischio basso',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: 'opn-363',
    programmaDa: 'formazione-specifica-rischio-basso-4h',
    immagine: '/img/corsi/formazione-specifica-rischio-basso-4h-eng.webp',
    prezzo: 50,
  },
  {
    id: 'formazione-generale-specifica-rischio-basso-8h',
    categoria: 'lavoratori',
    titolo: 'Formazione generale + specifica — rischio basso',
    titoloAttestato: 'CORSO DI FORMAZIONE GENERALE E SPECIFICA DEI LAVORATORI PER I SETTORI DELLA CLASSE DI RISCHIO BASSO - 8 ORE',
    ore: 8,
    aggiornamento: false,
    destinatari: 'Neoassunti in settori a rischio basso: assolve l’intero obbligo formativo',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: 'coroma_445',
    idEnte: 60,
    immagine: '/img/corsi/formazione-generale-specifica-rischio-basso-8h.webp',
    prezzo: 59,
  },
  {
    id: 'formazione-generale-specifica-rischio-basso-8h-eng',
    categoria: 'lavoratori',
    titolo: 'Formazione generale + specifica — rischio basso — in inglese',
    titoloAttestato: 'GENERAL AND SPECIFIC TRAINING COURSE — LOW RISK',
    ore: 8,
    aggiornamento: false,
    destinatari: 'Neoassunti di lingua inglese in settori a rischio basso: assolve l’intero obbligo formativo',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: 'opn-365',
    programmaDa: 'formazione-generale-specifica-rischio-basso-8h',
    immagine: '/img/corsi/formazione-generale-specifica-rischio-basso-8h-eng.webp',
    prezzo: 50,
  },
  {
    id: 'aggiornamento-lavoratori-tutti-rischi-6h',
    categoria: 'lavoratori',
    titolo: 'Aggiornamento lavoratori — tutti i livelli di rischio',
    titoloAttestato: 'CORSO DI AGGIORNAMENTO DEI LAVORATORI PER TUTTI I LIVELLI DI RISCHIO (BASSO – MEDIO – ALTO) - 6 ORE',
    ore: 6,
    aggiornamento: true,
    destinatari: 'Lavoratori già formati, in scadenza quinquennale',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: 'corrnr_592',
    idEnte: 43,
    immagine: '/img/corsi/aggiornamento-lavoratori-tutti-rischi-6h.webp',
    prezzo: 49,
  },
  {
    id: 'aggiornamento-lavoratori-6h-eng',
    categoria: 'lavoratori',
    titolo: 'Aggiornamento lavoratori — in inglese',
    titoloAttestato: 'WORKERS’ REFRESHER TRAINING COURSE',
    ore: 6,
    aggiornamento: true,
    destinatari: 'Lavoratori di lingua inglese già formati, in scadenza quinquennale',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: 'opn-369',
    programmaDa: 'aggiornamento-lavoratori-tutti-rischi-6h',
    immagine: '/img/corsi/aggiornamento-lavoratori-6h-eng.webp',
    prezzo: 50,
  },
  {
    id: 'aggiornamento-lavoratori-rischio-medio-6h',
    sospeso: "Doppione: l'aggiornamento lavoratori (ASR 2025) è unico, 6 ore per tutti i livelli di rischio",
    categoria: 'lavoratori',
    titolo: 'Aggiornamento lavoratori — rischio medio',
    titoloAttestato: 'CORSO DI AGGIORNAMENTO DEI LAVORATORI - RISCHIO MEDIO - 6 ORE',
    ore: 6,
    aggiornamento: true,
    destinatari: 'Lavoratori di settori a rischio medio, in scadenza quinquennale',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: 'corsrr_297',
    idEnte: 56,
    immagine: '/img/corsi/aggiornamento-lavoratori-rischio-medio-6h.webp',
    prezzo: 49,
  },

  // ------------------------------------------------------------ DATORE DI LAVORO
  {
    id: 'datore-di-lavoro-16h',
    categoria: 'datore',
    titolo: 'Formazione datore di lavoro',
    titoloAttestato: 'CORSO DI FORMAZIONE DATORE DI LAVORO - 16 ORE',
    ore: 16,
    aggiornamento: false,
    destinatari: 'Datori di lavoro',
    normativa: 'D.Lgs. 81/2008',
    sku: 'cors-d_123',
    idEnte: 70,
    immagine: '/img/corsi/datore-di-lavoro-16h.webp',
    prezzo: 99,
  },
  {
    id: 'aggiornamento-datore-lavoro-6h',
    categoria: 'datore',
    titolo: 'Aggiornamento datore di lavoro',
    titoloAttestato: 'CORSO DI AGGIORNAMENTO PER DATORE DI LAVORO',
    ore: 6,
    aggiornamento: true,
    destinatari: 'Datori di lavoro già formati, aggiornamento quinquennale',
    normativa: 'D.Lgs. 81/2008',
    sku: 'opn-379',
    immagine: '/img/corsi/aggiornamento-datore-lavoro-6h.webp',
    prezzo: 50,
  },
  {
    id: 'datore-di-lavoro-16h-eng',
    categoria: 'datore',
    titolo: 'Formazione datore di lavoro — in inglese',
    titoloAttestato: 'TRAINING COURSE FOR EMPLOYERS',
    ore: 16,
    aggiornamento: false,
    destinatari: 'Datori di lavoro di lingua inglese',
    normativa: 'D.Lgs. 81/2008',
    sku: 'opn-378',
    programmaDa: 'datore-di-lavoro-16h',
    immagine: '/img/corsi/datore-di-lavoro-16h-eng.webp',
    prezzo: 50,
  },
  {
    id: 'rspp-datore-lavoro-8h',
    sospeso: "Formazione DL-RSPP non consentita in e-learning (solo presenza o videoconferenza sincrona)",
    categoria: 'datore',
    titolo: 'Datore di lavoro RSPP — moduli I e II',
    titoloAttestato: 'CORSO DI FORMAZIONE PER LO SVOLGIMENTO DIRETTO DA PARTE DEL DATORE DI LAVORO DEI COMPITI DI RESPONSABILE AL SERVIZIO DI PREVENZIONE E PROTEZIONE - MODULI I E II - 8 ORE',
    ore: 8,
    aggiornamento: false,
    destinatari: 'Datori di lavoro che svolgono direttamente i compiti di RSPP',
    normativa: 'D.Lgs. 81/2008, art. 34',
    sku: 'cosoa-_188',
    idEnte: 49,
    immagine: '/img/corsi/rspp-datore-lavoro-8h.webp',
    prezzo: 119,
  },
  {
    id: 'aggiornamento-rspp-datore-lavoro-8h',
    categoria: 'datore',
    titolo: 'Aggiornamento datore di lavoro RSPP',
    titoloAttestato: 'CORSO DI AGGIORNAMENTO PER DATORE DI LAVORO CHE SVOLGE DIRETTAMENTE I COMPITI DI PREVENZIONE E PROTEZIONE DAI RISCHI (RSPP DL) 8 ORE',
    ore: 8,
    aggiornamento: true,
    destinatari: 'Datori di lavoro RSPP in scadenza quinquennale',
    normativa: 'D.Lgs. 81/2008, art. 34',
    sku: 'corieo_173',
    idEnte: 78,
    immagine: '/img/corsi/aggiornamento-rspp-datore-lavoro-8h.webp',
    prezzo: 89,
  },
  {
    id: 'modulo-cantieri-datore-6h',
    categoria: 'datore',
    titolo: 'Modulo aggiuntivo "Cantieri" — datore di lavoro',
    titoloAttestato: 'CORSO DI FORMAZIONE MODULO AGGIUNTIVO “CANTIERI” per DATORE DI LAVORO (6 ore)',
    ore: 6,
    aggiornamento: false,
    destinatari: 'Datori di lavoro di imprese che operano in cantiere',
    normativa: 'D.Lgs. 81/2008, Titolo IV',
    sku: 'cordiz_385',
    idEnte: 76,
    immagine: '/img/corsi/modulo-cantieri-datore-6h.webp',
    prezzo: 79,
  },

  // ------------------------------------------------------------------ DIRIGENTI
  {
    id: 'dirigenti-12h',
    categoria: 'dirigenti',
    titolo: 'Formazione dirigenti',
    titoloAttestato: 'CORSO DI FORMAZIONE DEI DIRIGENTI - 12 ORE',
    ore: 12,
    aggiornamento: false,
    destinatari: 'Dirigenti con responsabilità organizzative in materia di sicurezza',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: 'coroio_352',
    idEnte: 83,
    immagine: '/img/corsi/dirigenti-12h.webp',
    prezzo: 149,
  },
  {
    id: 'aggiornamento-dirigenti-6h',
    categoria: 'dirigenti',
    titolo: 'Aggiornamento dirigenti',
    titoloAttestato: 'CORSO DI AGGIORNAMENTO DEI DIRIGENTI - 6 ORE',
    ore: 6,
    aggiornamento: true,
    destinatari: 'Dirigenti già formati, in scadenza quinquennale',
    normativa: 'D.Lgs. 81/2008, art. 37',
    sku: 'corggi_610',
    idEnte: 44,
    immagine: '/img/corsi/aggiornamento-dirigenti-6h.webp',
    prezzo: 69,
  },
  {
    id: 'modulo-cantieri-dirigenti-6h',
    categoria: 'dirigenti',
    titolo: 'Modulo aggiuntivo "Cantieri" — dirigenti',
    titoloAttestato: 'CORSO DI FORMAZIONE MODULO AGGIUNTIVO “CANTIERI” per DIRIGENTI (6 ore)',
    ore: 6,
    aggiornamento: false,
    destinatari: 'Dirigenti di imprese che operano in cantiere',
    normativa: 'D.Lgs. 81/2008, Titolo IV',
    sku: 'cortn__284',
    idEnte: 77,
    immagine: '/img/corsi/modulo-cantieri-dirigenti-6h.webp',
    prezzo: 79,
  },

  // ---------------------------------------------------------------- RSPP / ASPP
  {
    id: 'rspp-aspp-modulo-a-28h',
    categoria: 'rspp',
    titolo: 'RSPP e ASPP — Modulo A',
    titoloAttestato: 'CORSO DI FORMAZIONE PER RESPONSABILI E ADDETTI DEI SERVIZI DI PREVENZIONE E PROTEZIONE (RSPP E ASPP) MODULO A - 28 ORE',
    ore: 28,
    aggiornamento: false,
    destinatari: 'Aspiranti RSPP e ASPP: modulo base comune a tutti i settori',
    normativa: 'D.Lgs. 81/2008, art. 32',
    sku: 'rspppo_867',
    idEnte: 45,
    immagine: '/img/corsi/rspp-aspp-modulo-a-28h.webp',
    prezzo: 49,
  },
  {
    id: 'aggiornamento-rspp-40h',
    categoria: 'rspp',
    titolo: 'Aggiornamento RSPP',
    titoloAttestato: 'CORSO DI AGGIORNAMENTO PER RESPONSABILI DEI SERVIZI DI PREVENZIONE E PROTEZIONE (RSPP) - 40 ORE',
    ore: 40,
    aggiornamento: true,
    destinatari: 'RSPP in carica, aggiornamento quinquennale',
    normativa: 'D.Lgs. 81/2008, art. 32',
    sku: 'coroea_180',
    idEnte: 58,
    immagine: '/img/corsi/aggiornamento-rspp-40h.webp',
    prezzo: 99,
  },
  {
    id: 'aggiornamento-aspp-20h',
    categoria: 'rspp',
    titolo: 'Aggiornamento ASPP',
    titoloAttestato: 'CORSO DI AGGIORNAMENTO PER ADDETTI DEI SERVIZI DI PREVENZIONE E PROTEZIONE (ASPP) - 20 ORE',
    ore: 20,
    aggiornamento: true,
    destinatari: 'ASPP in carica, aggiornamento quinquennale',
    normativa: 'D.Lgs. 81/2008, art. 32',
    sku: 'cor-rm_653',
    idEnte: 61,
    immagine: '/img/corsi/aggiornamento-aspp-20h.webp',
    prezzo: 139,
  },

  // ----------------------------------------------------------------------- RLS
  {
    id: 'rls-32h',
    avviso: 'La formazione RLS non è regolata dall’Accordo Stato-Regioni ma dal contratto collettivo (CCNL) applicato in azienda (art. 37, comma 11, D.Lgs. 81/2008): è il CCNL a stabilire se il corso può essere seguito online. Prima di iscriverti verifica che il tuo CCNL, o l’accordo collettivo di riferimento, ammetta la formazione RLS in e-learning; se hai dubbi scrivici e la verifichiamo noi.',
    richiedeCcnl: true,
    categoria: 'rls',
    titolo: 'Formazione RLS',
    titoloAttestato: 'CORSO DI FORMAZIONE PER RAPPRESENTANTE DEI LAVORATORI PER LA SICUREZZA (RLS) - 32 ORE',
    ore: 32,
    aggiornamento: false,
    destinatari: 'Rappresentanti dei lavoratori per la sicurezza di nuova nomina',
    normativa: 'D.Lgs. 81/2008, art. 37 commi 10-11',
    sku: 'corona_906',
    idEnte: 51,
    immagine: '/img/corsi/rls-32h.webp',
    prezzo: 149,
  },
  {
    id: 'aggiornamento-rls-fino-50-4h',
    avviso: 'La formazione RLS non è regolata dall’Accordo Stato-Regioni ma dal contratto collettivo (CCNL) applicato in azienda (art. 37, comma 11, D.Lgs. 81/2008): è il CCNL a stabilire se il corso può essere seguito online. Prima di iscriverti verifica che il tuo CCNL, o l’accordo collettivo di riferimento, ammetta la formazione RLS in e-learning; se hai dubbi scrivici e la verifichiamo noi.',
    richiedeCcnl: true,
    categoria: 'rls',
    titolo: 'Aggiornamento RLS — aziende fino a 50 lavoratori',
    titoloAttestato: 'CORSO DI AGGIORNAMENTO PER RAPPRESENTANTE DEI LAVORATORI PER LA SICUREZZA PER IMPRESE CHE OCCUPANO FINO AI 50 LAVORATORI - 4 ORE',
    ore: 4,
    aggiornamento: true,
    destinatari: 'RLS di imprese fino a 50 dipendenti, aggiornamento annuale',
    normativa: 'D.Lgs. 81/2008, art. 37 comma 11',
    sku: 'cor-rl_382',
    idEnte: 46,
    immagine: '/img/corsi/aggiornamento-rls-fino-50-4h.webp',
    prezzo: 20,
  },
  {
    id: 'aggiornamento-rls-oltre-50-8h',
    avviso: 'La formazione RLS non è regolata dall’Accordo Stato-Regioni ma dal contratto collettivo (CCNL) applicato in azienda (art. 37, comma 11, D.Lgs. 81/2008): è il CCNL a stabilire se il corso può essere seguito online. Prima di iscriverti verifica che il tuo CCNL, o l’accordo collettivo di riferimento, ammetta la formazione RLS in e-learning; se hai dubbi scrivici e la verifichiamo noi.',
    richiedeCcnl: true,
    categoria: 'rls',
    titolo: 'Aggiornamento RLS — aziende oltre 50 lavoratori',
    titoloAttestato: 'CORSO DI AGGIORNAMENTO PER RAPPRESENTANTE DEI LAVORATORI PER LA SICUREZZA PER IMPRESE CHE OCCUPANO PIÙ DI 50 LAVORATORI - 8 ORE',
    ore: 8,
    aggiornamento: true,
    destinatari: 'RLS di imprese con oltre 50 dipendenti, aggiornamento annuale',
    normativa: 'D.Lgs. 81/2008, art. 37 comma 11',
    sku: 'cora-i_223',
    idEnte: 54,
    immagine: '/img/corsi/aggiornamento-rls-oltre-50-8h.webp',
    prezzo: 29,
  },

  // ------------------------------------------------------------------- CANTIERI
  {
    id: 'coordinatore-modulo-giuridico-8h',
    sospeso: "Non presente nel catalogo O.P.N. Italia Lavoro (il modulo giuridico ASR 2025 è di 28 ore)",
    categoria: 'cantieri',
    titolo: 'Coordinatore sicurezza — modulo normativo/giuridico',
    titoloAttestato: 'CORSO DI FORMAZIONE PER COORDINATORE DELLA SICUREZZA - MODULO NORMATIVO/GIURIDICO - 8 ORE',
    ore: 8,
    aggiornamento: false,
    destinatari: 'Aspiranti coordinatori per la progettazione e per l’esecuzione dei lavori',
    normativa: 'D.Lgs. 81/2008, art. 98 e Allegato XIV',
    sku: 'cormln_716',
    idEnte: 57,
    immagine: '/img/corsi/coordinatore-modulo-giuridico-8h.webp',
    prezzo: 79,
  },
  {
    id: 'aggiornamento-csp-cse-40h',
    sospeso: "Per l'aggiornamento coordinatori l'e-learning e consentito solo per il modulo giuridico",
    categoria: 'cantieri',
    titolo: 'Aggiornamento coordinatori CSP/CSE',
    titoloAttestato: 'CORSO DI AGGIORNAMENTO COORDINATORE PER LA PROGETTAZIONE E PER L’ESECUZIONE DEI LAVORI - 40 ORE',
    ore: 40,
    aggiornamento: true,
    destinatari: 'Coordinatori in carica, aggiornamento quinquennale',
    normativa: 'D.Lgs. 81/2008, art. 98 e Allegato XIV',
    sku: 'rspsas_820',
    idEnte: 47,
    immagine: '/img/corsi/aggiornamento-csp-cse-40h.webp',
    prezzo: 199,
  },

  // ------------------------------------------------------------------ FORMATORI
  {
    id: 'formatori-40h',
    sospeso: "Il corso formatori O.P.N. Italia Lavoro è di 24 ore",
    categoria: 'formatori',
    titolo: 'Formazione formatori — 40 ore',
    titoloAttestato: 'CORSO DI FORMAZIONE PER FORMATORI - 40 ORE',
    ore: 40,
    aggiornamento: false,
    destinatari: 'Chi vuole qualificarsi come formatore in materia di salute e sicurezza',
    normativa: 'D.I. 6 marzo 2013',
    sku: 'coraor_886',
    idEnte: 63,
    immagine: '/img/corsi/formatori-40h.webp',
    prezzo: 99,
  },
  {
    id: 'formatori-24h',
    categoria: 'formatori',
    titolo: 'Formazione formatori — 24 ore',
    titoloAttestato: 'CORSO DI FORMAZIONE PER FORMATORI - 24 ORE',
    ore: 24,
    aggiornamento: false,
    destinatari: 'Percorso ridotto per chi possiede già parte dei requisiti',
    normativa: 'D.I. 6 marzo 2013',
    sku: 'cor4ia_615',
    idEnte: 95,
    immagine: '/img/corsi/formatori-24h.webp',
    prezzo: 99,
  },
  {
    id: 'aggiornamento-formatori-24h',
    categoria: 'formatori',
    titolo: 'Aggiornamento formatori',
    titoloAttestato: 'CORSO DI AGGIORNAMENTO PER FORMATORI - 24 ORE',
    ore: 24,
    aggiornamento: true,
    destinatari: 'Formatori qualificati, aggiornamento triennale',
    normativa: 'D.I. 6 marzo 2013',
    sku: 'corg-t_163',
    idEnte: 59,
    immagine: '/img/corsi/aggiornamento-formatori-24h.webp',
    prezzo: 29,
  },

  // ---------------------------------------------------------------------- HACCP
  {
    id: 'responsabile-industria-alimentare',
    categoria: 'haccp',
    titolo: 'Responsabile industria alimentare (HACCP OSA)',
    titoloAttestato: 'CORSO DI FORMAZIONE PER RESPONSABILE INDUSTRIA ALIMENTARE - (HACCP OSA)',
    ore: 12,
    aggiornamento: false,
    destinatari: 'Titolari e responsabili di imprese del settore alimentare',
    normativa: 'Reg. CE 852/2004 e normativa regionale',
    sku: 'coradr_126',
    idEnte: 89,
    immagine: '/img/corsi/responsabile-industria-alimentare.webp',
    prezzo: 39,
  },
  {
    id: 'osa-rischio-elevato-8h',
    categoria: 'haccp',
    titolo: 'Alimentaristi — rischio elevato (cat. A)',
    titoloAttestato: 'CORSO DI FORMAZIONE PER OPERATORI DEL SETTORE ALIMENTARE RISCHIO ELEVATO CAT. A (OSA - HACCP ORE 8)',
    ore: 8,
    aggiornamento: false,
    destinatari: 'Chi manipola alimenti in attività a rischio elevato',
    normativa: 'Reg. CE 852/2004 e normativa regionale',
    sku: 'core_l_774',
    idEnte: 71,
    immagine: '/img/corsi/osa-rischio-elevato-8h.webp',
    prezzo: 29,
  },
  {
    id: 'osa-rischio-medio-6h',
    categoria: 'haccp',
    titolo: 'Alimentaristi — rischio medio (cat. B)',
    titoloAttestato: 'CORSO DI FORMAZIONE PER OPERATORI DEL SETTORE ALIMENTARE - RISCHIO MEDIO CAT.B (OSA - HACCP ORE 6)',
    ore: 6,
    aggiornamento: false,
    destinatari: 'Chi manipola alimenti in attività a rischio medio',
    normativa: 'Reg. CE 852/2004 e normativa regionale',
    sku: 'corees_172',
    idEnte: 73,
    immagine: '/img/corsi/osa-rischio-medio-6h.webp',
    prezzo: 25,
  },
  {
    id: 'aggiornamento-osa-4h',
    categoria: 'haccp',
    titolo: 'Aggiornamento alimentaristi (cat. A e B)',
    titoloAttestato: 'CORSO DI AGGIORNAMENTO DI OPERATORI DEL SETTORE ALIMENTARE CAT.A E CAT.B (OSA - RISCHIO ELEVATO E MEDIO - HACCP ORE 4)',
    ore: 4,
    aggiornamento: true,
    destinatari: 'Alimentaristi già formati, in scadenza',
    normativa: 'Reg. CE 852/2004 e normativa regionale',
    sku: 'corn_o_533',
    idEnte: 72,
    immagine: '/img/corsi/aggiornamento-osa-4h.webp',
    prezzo: 25,
  },
];

// Sconti quantita per iscrizioni multiple.
// Proposta dello studio di mercato (DA CONFERMARE): 5-9 -10%, 10-24 -15%, 25+ a preventivo.
export const scontiQuantita = [];

// Ogni corso porta con sé il programma didattico ufficiale dell'ente.
// i corsi in inglese o per settore usano i contenuti minimi del corso equivalente (sono fissati dalla normativa)
corsi.forEach((c) => { c.programma = programmi[c.id] || programmi[c.programmaDa] || []; });


// ---------------------------------------------------------------- PREZZO DI LANCIO
// "prezzo" e il prezzo pieno; "prezzoLancio" vale fino a "lancioFino" compreso
// (data italiana). Scaduto il lancio, il prezzo torna da solo quello pieno.
const oggiInItalia = () => new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Rome' });
export const inLancio = (c) => Boolean(c.prezzoLancio && c.lancioFino && oggiInItalia() <= c.lancioFino);
export const prezzoCorrente = (c) => (inLancio(c) ? c.prezzoLancio : c.prezzo);

// ---------------------------------------------------------------- SEO
// Titoli scritti come le persone cercano su Google ("corso haccp online",
// "corso datore di lavoro 16 ore"...). Il titolo visibile in pagina resta quello del corso.
const TITOLI_SEO = {
  'formazione-generale-lavoratori-4h': 'Corso Sicurezza Lavoratori Online – Formazione Generale 4 ore',
  'formazione-generale-lavoratori-4h-eng': 'Corso Sicurezza Lavoratori in Inglese Online – Generale 4 ore',
  'formazione-specifica-rischio-basso-4h': 'Corso Sicurezza Rischio Basso Online – Formazione Specifica 4 ore',
  'formazione-generale-specifica-rischio-basso-8h': 'Corso Sicurezza Lavoratori Rischio Basso Online 8 ore',
  'aggiornamento-lavoratori-tutti-rischi-6h': 'Aggiornamento Sicurezza Lavoratori Online 6 ore – Tutti i Rischi',
  'aggiornamento-lavoratori-rischio-medio-6h': 'Aggiornamento Sicurezza Lavoratori Rischio Medio Online 6 ore',
  'datore-di-lavoro-16h': 'Corso Datore di Lavoro Sicurezza Online 16 ore – Accordo 2025',
  'rspp-datore-lavoro-8h': 'Corso RSPP Datore di Lavoro Online 8 ore',
  'aggiornamento-rspp-datore-lavoro-8h': 'Aggiornamento RSPP Datore di Lavoro Online 8 ore',
  'modulo-cantieri-datore-6h': 'Modulo Cantieri Datore di Lavoro Online 6 ore – Accordo 2025',
  'dirigenti-12h': 'Corso Dirigenti Sicurezza Online 12 ore – Accordo 2025',
  'aggiornamento-dirigenti-6h': 'Aggiornamento Dirigenti Sicurezza Online 6 ore',
  'modulo-cantieri-dirigenti-6h': 'Modulo Cantieri Dirigenti Online 6 ore – Accordo 2025',
  'rspp-aspp-modulo-a-28h': 'Corso RSPP ASPP Modulo A Online 28 ore',
  'aggiornamento-rspp-40h': 'Aggiornamento RSPP Online 40 ore',
  'aggiornamento-aspp-20h': 'Aggiornamento ASPP Online 20 ore',
  'rls-32h': 'Corso RLS Online 32 ore – Rappresentante dei Lavoratori',
  'aggiornamento-rls-fino-50-4h': 'Aggiornamento RLS Online 4 ore – Aziende fino a 50 Lavoratori',
  'aggiornamento-rls-oltre-50-8h': 'Aggiornamento RLS Online 8 ore – Aziende oltre 50 Lavoratori',
  'coordinatore-modulo-giuridico-8h': 'Corso Coordinatore Sicurezza CSP CSE – Modulo Giuridico 8 ore',
  'aggiornamento-csp-cse-40h': 'Aggiornamento Coordinatore Sicurezza CSP CSE 40 ore',
  'formatori-40h': 'Corso Formatore Sicurezza sul Lavoro Online 40 ore',
  'formatori-24h': 'Corso Formatore Sicurezza sul Lavoro Online 24 ore',
  'aggiornamento-formatori-24h': 'Aggiornamento Formatore Sicurezza Online 24 ore',
  'responsabile-industria-alimentare': 'Corso HACCP Responsabile Industria Alimentare Online 12 ore',
  'osa-rischio-elevato-8h': 'Corso HACCP Online Rischio Elevato (Cat. A) 8 ore',
  'osa-rischio-medio-6h': 'Corso HACCP Online Rischio Medio (Cat. B) 6 ore',
  'aggiornamento-osa-4h': 'Aggiornamento HACCP Online 4 ore – Cat. A e B',
  'formazione-specifica-rischio-basso-turismo-4h': 'Corso Sicurezza Rischio Basso Turismo e Ristorazione Online 4 ore',
  'formazione-specifica-rischio-basso-uffici-4h': 'Corso Sicurezza Rischio Basso Uffici Online 4 ore – Formazione Specifica',
  'formazione-specifica-rischio-basso-4h-eng': 'Corso Sicurezza Rischio Basso in Inglese Online – Specifica 4 ore',
  'formazione-generale-specifica-rischio-basso-8h-eng': 'Corso Sicurezza Lavoratori in Inglese Rischio Basso Online 8 ore',
  'aggiornamento-lavoratori-6h-eng': 'Aggiornamento Sicurezza Lavoratori in Inglese Online 6 ore',
  'aggiornamento-datore-lavoro-6h': 'Aggiornamento Datore di Lavoro Sicurezza Online 6 ore – Accordo 2025',
  'datore-di-lavoro-16h-eng': 'Corso Datore di Lavoro Sicurezza in Inglese Online 16 ore',
};

/** Titolo e descrizione per Google: descrizione entro ~160 caratteri. */
export const seoCorso = (c, prezzo = c.prezzo) => {
  const titolo = TITOLI_SEO[c.id] || `${c.titolo} — corso online ${c.ore} ore`;
  const conformita = c.categoria === 'haccp' ? 'Reg. CE 852/2004' : 'Accordo Stato-Regioni 2025';
  const varianti = [
    `${titolo}. E-learning asincrono conforme a ${conformita}. ${prezzo} € a partecipante IVA compresa, attestato con QR code.`,
    `${titolo}. E-learning conforme a ${conformita}. ${prezzo} € IVA compresa, attestato con QR code.`,
    `${titolo}. E-learning, ${conformita}. ${prezzo} € IVA compresa, attestato con QR code.`,
  ];
  const descrizione = varianti.find((d) => d.length <= 160) || varianti[varianti.length - 1];
  return { titolo, descrizione };
};

// I corsi con "sospeso" restano in archivio ma non si vendono.
// "prezzo" restituito e quello da pagare oggi (di lancio, se attivo).
export const corsiPubblicabili = () => {
  const pubblicabili = corsi
    .filter((c) => c.prezzo !== null && !c.sospeso)
    .map((c) => ({ ...c, prezzo: prezzoCorrente(c), lancio: inLancio(c) }));
  return pubblicabili.map((c) => {
    const seo = seoCorso(c);
    return {
      ...c,
      seoTitolo: seo.titolo,
      seoDescrizione: seo.descrizione,
      // altri corsi della stessa area: collegamenti interni tra le schede
      correlati: pubblicabili
        .filter((x) => x.categoria === c.categoria && x.id !== c.id)
        .slice(0, 4)
        .map((x) => ({ id: x.id, titolo: x.titolo, ore: x.ore, prezzo: x.prezzo })),
    };
  });
};
